import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Chip,
  IconButton,
  Divider,
  Grid,
  Input,
  FormHelperText,
  TextField,
  Avatar,
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { ArrowBack, UploadFile } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { enqueueSnackbar } from "notistack";
import { useIds } from "../../hook/AdminContext";
import {
  apply_job_api,
  get_hr_blog_etail_api,
  get_live_job_feed_etail_api,
  favourite_live_job_api,
} from "../../DAL/partner/partners";
import PageLoading from "../../components/loader/PageLoading";
import {
  formatEducationRequired,
  show_des_data,
  show_proper_words,
} from "../../utils/Constant";
import { s3baseUri } from "../../config/config";

export default function PersonalJobDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const job = location.state?.job || {};
  const [bookmarked, setBookmarked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [cvName, setCvName] = useState(""); // State to store CV file name
  const [cv, setcv] = useState(); // State to store CV file name
  const [shortDescription, setShortDescription] = useState("");
  const { findId, setBreadCrumb, userInfo } = useIds();
  const [dataapi, setDataApi] = useState();
  const [bookmarkedJobs, setBookmarkedJobs] = useState({});

  const params = useParams();
  console.log(params, "paramsparamsparams");

  const firstSegment = location.pathname.split("/")[1];
  const fetchCategories = async () => {
    setLoading(true);
    const response = await get_live_job_feed_etail_api(params.id);
    console.log(response, "responseresponseresponseresponse");
    if (response.code === 200) {
      setDataApi(response.job);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchCategories();
  }, []);

  // Handle file selection
  const getFrequencyLabel = (freq) => {
    switch (freq) {
      case "Monthly":
        return "month";
      case "Yearly":
        return "year";
      case "Anually":
        return "annually";
      case "Weekly":
        return "week";
      case "Daily":
        return "day";
      case "Hourly":
        return "hour";
      default:
        return "";
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setcv(file);
    if (file) {
      setCvName(file.name);
    }
  };
  const formatSalaryFrequency = (frequency) => {
    switch (frequency) {
      case "Monthly":
        return "month";
      case "Yearly":
        return "year";
      case "Anually":
        return "annually";
      case "Weekly":
        return "week";
      case "Daily":
        return "day";
      case "Hourly":
        return "hour";
      default:
        return "";
    }
  };

  const handleBookmarkToggle = (jobId) => {
    console.log(jobId, "jobIdjobIdjobIdjobId");

    const newBookmarkedState = !bookmarkedJobs[jobId]; // Toggle state optimistically

    setBookmarkedJobs((prev) => {
      const updatedBookmarks = { ...prev, [jobId]: newBookmarkedState };
      localStorage.setItem("bookmarkedJobs", JSON.stringify(updatedBookmarks));
      return updatedBookmarks;
    });

    let id = { job_id: jobId };

    favourite_live_job_api(id)
      .then((response) => {
        console.log("API Response:", response);

        // Check if the API returns a specific message
        const successMessage = newBookmarkedState
          ? "Job added to favorites"
          : "Job removed from favorites";

        enqueueSnackbar(successMessage, { variant: "success" });
      })
      .catch((error) => {
        console.error("Error updating favorite job:", error);

        // Revert state in case of API failure
        setBookmarkedJobs((prev) => {
          const revertedBookmarks = { ...prev, [jobId]: !newBookmarkedState };
          localStorage.setItem(
            "bookmarkedJobs",
            JSON.stringify(revertedBookmarks)
          );
          return revertedBookmarks;
        });

        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };

  useEffect(() => {
    const storedBookmarks =
      JSON.parse(localStorage.getItem("bookmarkedJobs")) || {};
    setBookmarkedJobs(storedBookmarks);
  }, []);
  const HandleApplyJob = async () => {
    // if (!cvName) {
    //   enqueueSnackbar("Please attach your CV before applying!", {
    //     variant: "error",
    //   });
    //   return;
    // }
    let data = {
      Job_id: params.jobId,
      cv: cvName,
      job_description: shortDescription,
    };
    const formData = new FormData();
    formData.append("Job_id", params.id);
    formData.append("cv", cv);
    formData.append("job_description", shortDescription);
    // formData.append("description", inputs.description);

    console.log(formData, "formDataformDataformData");

    const response = await apply_job_api(formData);
    console.log(response, "responseresponseresponseresponse");
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      setLoading(false);
      navigate(-1);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
  };
  let icon = {
    iconBg: "#000080",
  };
  const salaryFrequency = (type) => {
    switch (type) {
      case "Monthly":
        return "month";
      case "Yearly":
        return "year";
      case "Anually":
        return "annually";
      case "Weekly":
        return "week";
      case "Daily":
        return "day";
      case "Hourly":
        return "hour";
      default:
        return "";
    }
  };

  const navigeBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
      {
        name: `Live Job Feed`,
        path: `/${firstSegment}/live-job-feed`,
        active: false,
      },
      {
        name: `My Job Posts`,
        path: `/${firstSegment}/live-job-feed/personal-jobs`,
        active: false,
      },
      {
        name: `My Job Post Detail`,
        path: ``,
        active: true,
      },
    ]);
  }, []);

  if (loading) {
    return <PageLoading />;
  }
  return (
    <Box sx={{ mx: "auto", mt: 1, p: { xs: 2, sm: 3 }, pb: 12 }}>
      {/* Job Title & Company Info */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexDirection={{ xs: "row", sm: "row" }}
        gap={2}
      >
        <Box display="flex" alignItems="center" gap={2} width="100%">
          <Avatar
            src={s3baseUri + job?.creater_info?.profile_image}
            alt=""
            sx={{
              width: 50,
              height: 50,
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <Box>
            <Typography variant="h6" fontWeight="bold">
              {dataapi?.jobTitle}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: "13px", mt: 0.5 }}
            >
              {dataapi?.location}
            </Typography>
          </Box>
        </Box>
        {userInfo?.type === 1 && (
          <IconButton onClick={() => handleBookmarkToggle(job._id)}>
            {bookmarkedJobs[job._id] ? (
              <BookmarkIcon sx={{ color: "#000080" }} />
            ) : (
              <BookmarkBorderIcon />
            )}
          </IconButton>
        )}
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Job Details Section */}
      <Grid container spacing={3}>
        {/* Left Column */}
        <Grid item xs={12} md={8}>
          <Grid container spacing={3}>
            {[
              { title: "Job Type", value: dataapi?.jobType },
              {
                title: "Experience",
                value: show_des_data(dataapi?.experienceRequired),
              },
              ...(dataapi?.maxSalary && dataapi?.minSalary
                ? [
                    {
                      title: "Max Salary",
                      value: `€${dataapi?.maxSalary}/${salaryFrequency(
                        dataapi?.frequencySalary
                      )}`,
                    },
                    {
                      title: "Min Salary",
                      value: `€${dataapi?.minSalary}/${
                        dataapi?.frequencySalary?.toLowerCase() || ""
                      }`,
                    },
                  ]
                : [
                    {
                      title: "Fixed Salary",
                      value: `€${dataapi?.salary || "N/A"}/${
                        dataapi?.frequencySalary?.toLowerCase() || ""
                      }`,
                    },
                  ]),
            ].map((item, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Typography variant="h6" fontWeight="bold">
                  {item.title || item.label}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ mt: 1, fontSize: "16px", lineHeight: "1.6" }}
                >
                  {item.value}
                </Typography>
              </Grid>
            ))}
          </Grid>

          <Typography variant="h6" fontWeight="bold" sx={{ mt: 3 }}>
            Education
          </Typography>
          <Box sx={{ mt: 1 }}>
            <Typography variant="body1">
              {formatEducationRequired(dataapi?.educationRequired)}
            </Typography>
          </Box>

          <Typography variant="h6" fontWeight="bold" sx={{ mt: 3 }}>
            Job Description
          </Typography>
          <Typography
            variant="body1"
            sx={{ mt: 2, fontSize: "15px" }}
            dangerouslySetInnerHTML={{ __html: dataapi.description }}
          />
        </Grid>

        {/* Right Column Placeholder */}
        <Grid item xs={12} md={4}></Grid>
      </Grid>

      {/* Upload CV Display */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          mt: 4,
          px: 2,
          gap: 2,
        }}
      >
        {cvName && (
          <Box
            sx={{
              position: "relative",
              border: "1px solid silver",
              borderRadius: "5px",
              p: 1,
              maxWidth: "100%",
            }}
          >
            <IconButton
              size="small"
              sx={{
                position: "absolute",
                top: "-10px",
                right: "-5px",
                backgroundColor: "red",
                color: "white",
                padding: "1px",
                fontSize: "10px",
              }}
              onClick={() => setCvName(null)}
            >
              <CloseIcon sx={{ fontSize: "15px" }} />
            </IconButton>
            <Typography sx={{ fontSize: "13px", wordBreak: "break-word" }}>
              {cvName}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
